import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Ana səhifə', path: '/' },
    { name: 'Çantalar', path: '/bags' },
    { name: 'Məhsullar', path: '/products' },
    { name: 'Haqqımızda', path: '/about' },
    { name: 'Əlaqə', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav 
      className="sticky top-0 z-50 bg-brand-cream/90 backdrop-blur-md border-b border-brand-secondary/50"
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link 
            to="/" 
            className="font-serif text-2xl md:text-3xl text-brand-brown tracking-tight"
            data-testid="navbar-logo"
          >
            Turkan <span className="text-brand-primary italic">Rustamova</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-300 ${
                  isActive(link.path)
                    ? 'text-brand-primary'
                    : 'text-brand-brown hover:text-brand-primary'
                }`}
                data-testid={`nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.name}
              </Link>
            ))}
            {/* <Link
              to="/admin"
              className="rounded-full bg-gradient-to-r from-brand-primary to-[#E08E73] text-white px-6 py-2 text-sm font-medium hover:shadow-warm transition-all duration-300"
              data-testid="nav-admin-link"
            >
              Admin
            </Link> */}
          </div>

          {/* Mobile Menu Button */}
          {/* <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 text-brand-brown"
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button> */}
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-brand-cream z-40 flex flex-col items-center justify-center md:hidden"
          data-testid="mobile-menu"
        >
          <button
            onClick={() => setIsOpen(false)}
            className="absolute top-6 right-6 p-2 text-brand-brown"
            aria-label="Close menu"
          >
            <X className="w-8 h-8" />
          </button>
          <nav className="flex flex-col items-center space-y-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`font-serif text-3xl transition-colors duration-300 ${
                  isActive(link.path)
                    ? 'text-brand-primary'
                    : 'text-brand-brown hover:text-brand-primary'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/admin"
              onClick={() => setIsOpen(false)}
              className="mt-4 rounded-full bg-gradient-to-r from-brand-primary to-[#E08E73] text-white px-8 py-3 text-lg font-medium"
            >
              Admin Panel
            </Link>
          </nav>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
